import { render, staticRenderFns } from "./OfferPerspectiveRulesTable.vue?vue&type=template&id=28ede51c&scoped=true"
import script from "./OfferPerspectiveRulesTable.vue?vue&type=script&lang=js"
export * from "./OfferPerspectiveRulesTable.vue?vue&type=script&lang=js"
import style0 from "./OfferPerspectiveRulesTable.vue?vue&type=style&index=0&id=28ede51c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ede51c",
  null
  
)

export default component.exports